<template>
  <div class="container top-0 z-index-sticky">
    <div class="row">
      <div class="col-12">
        <div class="navbar navbar-expand-lg top-0 z-index-3 position-absolute mt-4 blur
                     border-radius-lg my-3 py-3 start-0 end-0 mx-4 shadow text-center">
          <div class="w-100 f-17"> سامانه جامع تیکتینگ </div>
        </div>
      </div>
    </div>
  </div>
  <main class="mt-0 main-content main-content-bg">
    <div class="page-header min-vh-100"
         :style="{backgroundImage : 'url(' + require('@/assets/img/bg/login_bg.jpg') +')' }"
         id="div_background">
      <span class="mask bg-gradient-dark opacity-6"></span>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-7 mt-2">
            <div class="card border-0 mb-0">
              <div class="pb-0 card-header text-start">
                <h4 class="font-weight-bolder text-end">ورود</h4>
                <p class="mb-0 text-end">کلمه کاربری و رمز عبور خود را وارد کنید</p>
              </div>
              <div class="card-body">
                <form @submit.prevent="formSubmit" @keyup.enter="formSubmit">
                  <div class="mb-3">
                    <input type="text"
                           placeholder="کلمه کاربری"
                           class="form-control form-control-lg"
                           v-model="userModel.UserName" />
                  </div>
                  <div class="mb-3">
                    <input type="password"
                           placeholder="رمز عبور"
                           class="form-control form-control-lg"
                           v-model="userModel.Password" />
                  </div>
                  <div class="text-center">
                    <button type="submit" :disabled="lockButton" class="mt-4 btn bg-gradient-purple c-white w-100 btn-lg">
                      <template v-if="lockButton">
                        <fa-icon icon="fas fa-spinner fa-spin-pulse" class="fa-spin fa-fw fa-xl"></fa-icon>
                      </template> ورود
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <div class="container bottom-0 position-sticky z-index-sticky pb-4 d-none">
    <div class="row">
      <div class="col-12">
        ©
        {{ new Date().getFullYear() }}, تمامی حقوق مادی و معنوی محصول
        متعلق به
        <a href="#"
           class="font-weight-bold"
           target="_blank">{{ $store.state.company_title}} </a>
        می باشد. نسخه {{ $store.state.appVersion }}
      </div>
    </div>
  </div>
</template>

<script>
import PersonService from "@/services/Person/Person-service";
import CompanyService from "@/services/Company/Company-service";
import CustomerService from "@/services/Company/Customer-service";
import TicketNotificationService from "../../services/Notification/TicketNotificationService";
import { setupConnection, stopConnection } from "../../services/SignalR/NotificationHubService";
import { mapMutations } from "vuex";
import store from "../../store";

  export default {
    name: "signin",
    data() {
      return {
        userModel: {
          UserName: '',
          Password: ''
        },
        lockButton: false
      };
    },
    methods: {
      ...mapMutations(["setCurrentUserInfo"]),
      checkForm() {
        let msg = '';

        if (this.userModel.UserName == '' &&
          this.userModel.Password == '') {
          msg = 'لطفا کلمه کاربری و رمز عبور را وارد کنید';
        }
        else if (this.userModel.UserName == '')
          msg += "لطفا کلمه کاربری را وارد کنید";
        else if (this.userModel.Password == '')
          msg += "لطفا رمز عبور را وارد کنید";

        if (msg.length > 0)
          this.$toast.error(msg);

        return msg.length == 0;
      },
      formSubmit() {
        if (!this.checkForm()) {
          return;
        }
        this.lockButton = true;

        PersonService.authentication(this.userModel).then(response => {
          let result = response.data;

          if (!result.success) {
            this.lockButton = false;
            this.$toast.error(result.message);
          }
          else {
            this.setCurrentUserInfo({
              user_name: result.data.user_name,
              token: result.data.token
            });
            setTimeout(() => { this.getUserInfo() }, 100);
          }
        }).catch(e => {
          this.lockButton = false;
          console.log(e);
        });
      },
      getUserInfo() {
        PersonService.getCurrentUserInfo().then(response => {
          let result = response.data;

          if (!result.success) {
            this.lockButton = false;
            this.$toast.error(result.message);
          }
          else {
            this.setCurrentUserInfo(result.data);
            if (result.data.isCompanyUser) { this.getUserCompanies(result.data.companyId); }
            else if (result.data.customerId > 0) { this.getUserCustomers(result.data.customerId); }
            else { this.getUserPermissions(result.data.id); }
          }
        }).catch(e => {
          this.lockButton = false;
          console.log(e);
        });
      },
      getUserPermissions(userId) {
        PersonService.getPermissionsByUser(userId).then(response => {
          let result = response.data;

          if (!result.success) {
            this.lockButton = false;
            this.$toast.error(result.message);
          }
          else {
            this.setCurrentUserInfo({ permissions: result.data });
            
            localStorage.setItem('user_info', JSON.stringify(this.$store.state.currentUserInfo));

            this.$toast.success('ورود موفقیت آمیز. خوش آمدید');

            Notification.requestPermission();

            this.getTicketNotifications();

            let route = '/main';

            if (!this.$store.state.currentUserInfo.isCompanyUser
                  | result.data.findIndex((v) => { return (v.permissionCode == 1140 | v.permissionCode == 1130) }) > 0)
              route = {path: '/myTickets'};
            // else {
            //   let index = result.data.findIndex((v) => { return v.permissionCode == 1140 });
      
            //   if (index > 0) {
            //     route = {path: '/referredTickets', query: {tabKey: 1, pageIndex: 0, pageSize: 20}};
            //   }
            //   else {
            //     let index = result.data.findIndex((v) => { return v.permissionCode == 1130 });
      
            //     if (index > 0) {
            //       route = {path: '/myTickets', query: {tabKey: 1, pageIndex: 0, pageSize: 20}};
            //     }
            //   }
            // }

            setTimeout(() => setupConnection(), 1000);

            setTimeout(() => this.$router.push(route), 500);
          }
        }).catch(e => {
          this.lockButton = false;
          console.log(e);
        });
      },
      getUserCompanies(companyId) {
        CompanyService.getUserCompanies(companyId).then(response => {
          let result = response.data;

          if (!result.success) {
            this.lockButton = false;
            this.$toast.error(result.message);
          }
          else {
            this.setCurrentUserInfo({ companies: result.data })
            this.getUserCustomersByCompany(result.data.allIds);
          }
        }).catch(e => {
          this.lockButton = false;
          console.log(e);
        });
      },
      getUserCustomersByCompany(companyIds) {
        CustomerService.getUserCustomersByCompany(companyIds).then(response => {
          let result = response.data;

          if (!result.success) {
            this.lockButton = false;
            this.$toast.error(result.message);
          }
          else {
            this.setCurrentUserInfo({ customers: result.data })
            this.getUserPermissions(this.$store.state.currentUserInfo.id);
          }
        }).catch(e => {
          this.lockButton = false;
          console.log(e);
        });
      },
      getUserCustomers(customerId) {
        CustomerService.getUserCustomersByCustomer(customerId).then(response => {
          let result = response.data;

          if (!result.success) {
            this.lockButton = false;
            this.$toast.error(result.message);
          }
          else {
            this.setCurrentUserInfo({ customers: result.data })
            this.getUserPermissions(this.$store.state.currentUserInfo.id);
          }
        }).catch(e => {
          this.lockButton = false;
          console.log(e);
        });
      },
      getTicketNotifications() {
        TicketNotificationService.getTicketNotificationsForCurrentUser(true).then(response => {
          let result = response.data;

          if (result.success) {
            store.dispatch("addListNewNotifications", result.data);
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        })
      },
    },
    created() {
      this.$store.state.showNavbar = false;
      this.$store.state.showSidenav = false;
      this.$store.state.showFooter = true;
    },
    mounted() {
      setTimeout(() => stopConnection(), 1000);
    },
    beforeUnmount() {
      this.$store.state.showNavbar = true;
      this.$store.state.showSidenav = true;
      this.$store.state.showFooter = true;
    },
  };
</script>
